const actionScope = '[Payment Management Active]';

export class LoadPaymentManagementActive {
  static readonly type = `${actionScope} Load Payment Management Active`;
}

export class SetPaymentManagementInactive {
  static readonly type = `${actionScope} Set Payment Management Inactive`;
}
